import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

// Login Redux States
import { DELETE_ENTRY_STRATEGY } from './actionTypes';
import { deleteEntryStrategySuccessful, deleteEntryStrategyFailed } from './actions';

// Include call API
import { getEntryStrategiesAPI } from '../../../api/entryestrategies';

const entryStrategiesAPI = getEntryStrategiesAPI();

function* deleteEntryStrategy({ payload: { id, token, history } }) {
  try {
    const response = yield call(entryStrategiesAPI.deleteEntryStrategy, { id, token });
    yield put(deleteEntryStrategySuccessful(response.message));
    history.go();
  } catch (error) {
    yield put(deleteEntryStrategyFailed(error));
  }
}

export function* watchDeleteEntryStrategy() {
  yield takeEvery(DELETE_ENTRY_STRATEGY, deleteEntryStrategy);
}

function* deleteEntryStrategySaga() {
  yield all([fork(watchDeleteEntryStrategy)]);
}

export default deleteEntryStrategySaga;
